import { SchoolApi } from 'api/schoolApi';
import { SubscriptionsApi } from 'api/subscriptionsApi';
import { ICountry, SchoolParser } from 'pages/manageSchool/models';
import { useCallback, useEffect, useState } from 'react';

export const useFetchSchoolInfo = (upgrade_subscription: boolean) => {
  const [schoolInfo, setSchoolInfo] = useState<any>(null);
  const [error, setError] = useState<string>('');

  const getSchoolInfo = useCallback(async () => {
    if (upgrade_subscription) {
      const result = await SubscriptionsApi.getSchoolInfo();

      if (result.data) {
        setSchoolInfo(result.data);
      }

      if (result.error) {
        setError(result.error);
      }
    } else {
      let countryData: ICountry[] = [];
      const countryListResult = await SchoolApi.getCountriesList();
      const data = countryListResult.data.details;

      if (data) {
        countryData = data.countries.map((item: ICountry) =>
          SchoolParser.parseCountryList(item)
        );
      }

      setSchoolInfo({
        schoolUrn: '',
        schoolname: '',
        phoneNumber: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        townCity: '',
        county: '',
        country: '',
        postcodeZipcode: '',
        countryList: countryData ?? [],
      });
    }
  }, []);

  useEffect(() => {
    getSchoolInfo();
  }, [getSchoolInfo]);

  return { schoolInfo, error };
};
